import toast from 'react-hot-toast';
import { setNotifications } from 'src/redux-store/slices/notificationSlice';
import { httpRequest } from 'src/services/httpRequest';

export const sendNotification = async (socket, data) => {
  const recipientUserId = Number(data?.UserID);
  const senderUserId = Number(data?.SenderID);

  // Applicant and sender are the same user (e.g. admin created own application)
  if (
    Number.isFinite(recipientUserId) &&
    Number.isFinite(senderUserId) &&
    recipientUserId === senderUserId
  ) {
    return;
  }

  // Emit the event to notify a specific user with a callback
  await socket?.emit(
    'notifyToUser',
    data?.UserID, // receiver user ID
    data?.TownshipID,
    JSON.stringify(data),
    data?.Message,
    (response) => {

      if (response?.status === 'success') {
        alert(
          `Notification successfully sent to ${data?.UserID}: "${data?.Message}"`
        );
      } else {
        alert(
          `Failed to send notification. Reason: ${response?.error || 'Unknown error'
          }`
        );
      }
    }
  );
};

// This function is used to fetch notifications from the server and dispatch them to the Redux store
export const handleGetNotification = async (dispatch) => {
  try {
    const response = await httpRequest(
      'GET',
      `/notification/handleGetNotification`
    );
    if (response.status === 'success') {
      const data = response?.data?.result;
      dispatch(setNotifications(data));
    } else if (response.type === 'NETWORK_ERROR') {
    } else {
      toast?.error(response?.message);
    }
  } catch (error) {
    toast?.error(error);
  }
};
